const MuteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
    >
      <path
        d="M1.3125 0.382812L5.33203 3.5L8.3125 0.847656H9.625V6.83594L11.4297 8.25781L11.2656 8.03906C11.5938 7.79297 11.8125 7.41016 11.8125 6.97266C11.8125 6.5625 11.5938 6.17969 11.2656 5.93359L12.0586 4.89453C12.6875 5.35938 13.125 6.125 13.125 6.97266C13.125 7.73828 12.7969 8.42188 12.2773 8.91406L13.3164 9.70703C14 8.99609 14.4375 8.03906 14.4375 6.97266C14.4375 5.6875 13.8086 4.56641 12.8516 3.82812L13.6445 2.78906C14.9023 3.74609 15.75 5.27734 15.75 6.97266C15.75 8.33984 15.2305 9.59766 14.3555 10.5273L16.9531 12.5508L17.4727 12.9336L16.6797 13.9727L16.1602 13.5898L0.519531 1.42188L0 1.01172L0.792969 0L1.3125 0.382812ZM6.37109 4.32031L8.3125 5.82422V2.625L6.37109 4.32031ZM2.21484 4.34766L3.88281 5.66016H2.1875V8.28516H4.86719L5.22266 8.64062L8.3125 11.3477V9.16016L9.625 10.1992V13.0977H8.3125L4.375 9.59766H0.875V4.34766H2.21484Z"
        fill="white"
      />
    </svg>
  );
};

export default MuteIcon;
